<template lang='pug'>
.main-container

  .view-content

    el-card
      div(slot='header')
        i.mat-icon import_contacts
        | Address Book
        el-button(type="primary", @click="goToAddressBuilder", style='float: right')
          i.mat-icon add_circle
          | Add address
      el-table(:data='addresses', v-loading='addresses == null')
        el-table-column(label='Address')
          template(slot-scope='scope')
            | {{scope.row.address_line_1}}
            br
            | {{scope.row.address_line_2}}
        el-table-column(label='City')
          template(slot-scope='scope')
            | {{scope.row.city}}, {{scope.row.state}}
        el-table-column(label='Zip code', prop='zip_code')
        el-table-column(label='Actions')
          template(slot-scope='scope')
            el-button(type='text' size='small', @click='deleteAddressDialog(scope.row.id)') Delete

    el-card
      div(slot='header')
        i.mat-icon person_pin_circle
        | Contacts
        el-button(type="primary", @click="goToContactBuilder", style='float: right')
          i.mat-icon add_circle
          | Add contact
      el-table(:data='contacts', v-loading='contacts == null')
        el-table-column(prop='name', label='Date')
          template(slot-scope='scope')
            | {{scope.row.salutation}} {{scope.row.first_name}} {{scope.row.last_name}}
        el-table-column(prop='phone_number', label='Phone Number')
        el-table-column(label='Actions')
          template(slot-scope='scope')
            el-button(type='text' size='small', @click='deleteContactDialog(scope.row.id)') Delete
  router-view
</template>

<script>
import Toolbar from '../layout/Toolbar.vue'

function data(){
  return {
    contacts: null,
    addresses: null,
    loadingAddresses: true,
    loadingContacts: true
  }
}

function getAddresses(){
  this.loadingAddresses = true
  return this.$simplecater.get('/addresses').then((r)=> {
    this.addresses = r.data.data
    this.loadingAddresses = false
  })
}

function getContacts(){
  this.loadingContacts = true
  return this.$simplecater.get('/contacts').then((r)=> {
    this.contacts = r.data.data
    this.loadingContacts = false
  })
}

function goToAddressBuilder(){
  this.$router.push("/user/address_book/new_address")
}


function goToContactBuilder(){
  this.$router.push("/user/address_book/new_contact")
}

function deleteAddressDialog ( id ) {
  const title = "Delete Address"
  const msg = "The address will be deleted. Continue?"
  this.$confirm(msg, title, {
    confirmButtonText: 'Yes, delete',
    cancelButtonText: 'Cancel',
    type: 'warning'
  }).then(() => {
    this.deleteAddress(id)
  }).catch(() => { })
}

function deleteAddress ( id ) {
  const target = `/addresses/${id}`
  this.$simplecater.delete(target).then(r => {
    this.$message("The address has been deleted")
    this.getAddresses()
  }).catch(()=>{
    this.$message.error("Deleting failed. Address might have been already used elsewhere.")
  })
}

function deleteContactDialog ( id ) {
  const title = "Delete Contact"
  const msg = "The contact will be deleted. Continue?"
  this.$confirm(msg, title, {
    confirmButtonText: 'Yes, delete',
    cancelButtonText: 'Cancel',
    type: 'warning'
  }).then(() => {
    this.deleteContact(id)
  }).catch(() => { })
}

function deleteContact ( id ) {
  const target = `/contacts/${id}`
  this.$simplecater.delete(target).then(r => {
    this.$message("The contact has been deleted")
    this.getContacts()
  }).catch(()=>{
    this.$message.error("Deleting failed. Contact might have been already used elsewhere.")
  })
}

function created(){
  this.getAddresses()
  this.getContacts()
  this.$bus.$on('address-saved', this.getAddresses)
  this.$bus.$on('contact-saved', this.getContacts)
}

const watch = {
  '$route' (to, from) {
    console.log("Reloading data")
    this.getAddresses()
    this.getContacts()
  }
}

const components = { Toolbar }

const methods = {
  getAddresses, getContacts, goToAddressBuilder,
  goToContactBuilder, deleteAddressDialog, deleteAddress,
  deleteContactDialog, deleteContact
}

export default { methods, components, data, created, watch }

</script>



// WEBPACK FOOTER //
// src/user/AddressBook.vue